import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { MdClose } from "react-icons/md";
import tw from "tailwind-styled-components";
import { ActionSection, SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";

const DateFilterModal = ({
    onApplyFilter,
    handleClose,
    currentFilter,
    handleClearFilters,
}) => {
    const [selectedValue, setSelectedValue] = useState(null);
    const [height, setHeight] = useState(window.innerHeight);

    const filterOptions = [
        { value: "1-5", label: "1-5" },
        { value: "6-10", label: "6-10" },
        { value: "11-15", label: "11-15" },
        { value: "16-20", label: "16-20" },
        { value: "21-25", label: "21-25" },
        { value: "26-31", label: "26-31" },
    ];

    useEffect(() => {
        if (currentFilter?.value) {
            setSelectedValue(currentFilter.value);
        } else {
            setSelectedValue(null);
        }
    }, [currentFilter]);

    useEffect(() => {
        const resize = () => setHeight(window.innerHeight);
        window.addEventListener("resize", resize);
        return () => window.removeEventListener("resize", resize);
    }, []);

    const handleApply = () => {
        if (!selectedValue) {
            toast.error("Please select a range.");
            return;
        }
        onApplyFilter(selectedValue);
    };

    return (
        <Container style={{ height }}>
            {/* Header */}
            <Header>
                <h1 className="text-lg font-medium text-white">Date Filter</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </Header>

            {/* Body */}
            <Body>
                {/* LEFT – Filter Types */}
                <LeftPane>
                    <TypeItem active={true}>
                        Day Range
                    </TypeItem>
                </LeftPane>

                {/* RIGHT – Options */}
                <RightPane>
                    <FilterTitle>Select Day Range</FilterTitle>

                    {filterOptions.map((option) => {
                        const checked = selectedValue === option.value;

                        return (
                            <OptionRow
                                key={option.value}
                                onClick={() => setSelectedValue(option.value)}
                            >
                                <input
                                    type="radio"
                                    checked={checked}
                                    readOnly
                                    style={{ margin: 0, width: 16 }}
                                />
                                <span className="leading-tight text-sm text-gray-600">
                                    Days {option.label}
                                </span>
                            </OptionRow>
                        );
                    })}
                </RightPane>
            </Body>

            {/* Footer */}
            <ActionSection>
                <SideCancelBtn type="button" onClick={handleClearFilters}>
                    Clear
                </SideCancelBtn>
                <SubmitBtn type="submit" onClick={handleApply}>
                    Apply Filter
                </SubmitBtn>
            </ActionSection>
        </Container>
    );
};

const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Header = tw.div`flex items-center justify-between bg-primary-color px-4 py-4`;

const Body = tw.div`flex flex-1 overflow-hidden`;

const LeftPane = tw.div`
  w-1/3 bg-gray-50 border-r overflow-y-auto`;

const TypeItem = tw.div`
  px-4 py-4 cursor-pointer text-md
  ${({ active }) =>
        active
            ? "bg-blue-50 text-primary-color font-medium border-l-4 border-primary-color"
            : "text-gray-700 hover:bg-gray-100"}
`;

const RightPane = tw.div`
  flex-1
  py-4
  pl-4
  pr-6
  overflow-y-auto
`;

const OptionRow = tw.div`
  flex items-center gap-3
  py-3 px-2
  cursor-pointer
  text-sm text-gray-400
  rounded-md
  hover:bg-gray-50
`;

const FilterTitle = tw.h3`text-md font-medium text-gray-700 mb-4`;

export default DateFilterModal;